export interface ProfileUnavailabilityRefreshPayload {
	startDate: string;
	endDate: string;
	morning: boolean;
	afternoon: boolean;
	evening: boolean;
	night: boolean;
	reason?: string;
	comment?: string;
}

export enum DayPeriod {
	NIGHT = 'night',
	MORNING = 'morning',
	AFTERNOON = 'afternoon',
	EVENING = 'evening',
}
